export default "__VITE_ASSET__CHS$lqEJ__"